import React, { useState, useEffect } from 'react';
import {
  isoDateToDMYDisplay,
  dmyDisplayToIsoDate,
  digitsFromDateInput,
  maskDigitsToDMYDisplay,
  parseGameDateForCsv
} from '../../utils/dateLocale';

/**
 * dd/mm/yyyy with digit-only auto-format (slashes inserted as you type).
 * value / onChange use ISO YYYY-MM-DD for the API.
 */
export function DateInputDMY({
  id,
  value,
  onChange,
  language = 'en',
  className,
  style,
  required,
  disabled
}) {
  const iso = value || '';
  const [text, setText] = useState(() => isoDateToDMYDisplay(iso));

  useEffect(() => {
    setText(isoDateToDMYDisplay(iso));
  }, [iso]);

  const placeholder = language === 'he' ? 'יום/חודש/שנה' : 'dd/mm/yyyy';
  const title =
    language === 'he'
      ? 'הזן 8 ספרות: יום, חודש, שנה — הקו נוסף אוטומטית'
      : 'Type digits only; slashes are added automatically (dd/mm/yyyy)';

  return (
    <input
      id={id}
      type="text"
      inputMode="numeric"
      autoComplete="off"
      spellCheck={false}
      placeholder={placeholder}
      title={title}
      maxLength={10}
      className={className}
      style={style}
      required={required}
      disabled={disabled}
      value={text}
      onPaste={(e) => {
        const pasted = e.clipboardData?.getData('text')?.trim() ?? '';
        if (!pasted) return;
        const iso = parseGameDateForCsv(pasted);
        if (iso) {
          e.preventDefault();
          onChange(iso);
          setText(isoDateToDMYDisplay(iso));
        }
      }}
      onChange={(e) => {
        const digits = digitsFromDateInput(e.target.value);
        const formatted = maskDigitsToDMYDisplay(digits);
        setText(formatted);
        if (!digits.length) {
          onChange('');
          return;
        }
        if (digits.length === 8) {
          const parsed = dmyDisplayToIsoDate(formatted);
          if (parsed) onChange(parsed);
        }
      }}
      onBlur={() => {
        const trimmed = text.trim();
        if (!trimmed) {
          onChange('');
          setText('');
          return;
        }
        const parsed = dmyDisplayToIsoDate(trimmed);
        if (parsed) {
          onChange(parsed);
          setText(isoDateToDMYDisplay(parsed));
        } else {
          setText(isoDateToDMYDisplay(iso));
        }
      }}
    />
  );
}
